import { useSyncExternalStore } from "react";
import { subscribe, getSubmissions, getTeachers, getAuth } from "./store";
import type { Submission, Teacher, AuthUser } from "./store";

// Cached, stable references for the server / initial-hydration snapshot.
// `useSyncExternalStore` requires getServerSnapshot to return the same value
// across calls, otherwise React throws "getServerSnapshot should be cached
// to avoid an infinite loop" and the error boundary shows.
const EMPTY_SUBS: Submission[] = [];
const EMPTY_TEACHERS: Teacher[] = [];
const NULL_AUTH: AuthUser | null = null;

export function useSubmissions() {
  return useSyncExternalStore(
    subscribe,
    () => getSubmissions(),
    () => EMPTY_SUBS,
  );
}
export function useTeachers() {
  return useSyncExternalStore(
    subscribe,
    () => getTeachers(),
    () => EMPTY_TEACHERS,
  );
}
export function useAuth() {
  return useSyncExternalStore(
    subscribe,
    () => getAuth(),
    () => NULL_AUTH,
  );
}
